module.exports = __webpack_public_path__ + "img/ic-donation-money.71769851.svg";